import { BsChevronRight } from "react-icons/bs";
import { CompletedActionsIcon, PendingActionsCardTriangle, PendingActionsIcon, WidgetLogoTransparent, CloseIcon, KnowHowToUseBuildrActionIcon } from "../../assets";
import { useLocation, useNavigate } from "react-router-dom";
import { IPendingCardSection } from "../../api/pending-card";
import { COMPUTER_LAB_SETUP_FEEDACK_LINK } from "../../constants";
import { Tooltip } from "antd";

export default function PendingActionsModal(
    { 
        collapsed,
        sections,
        isLoading,
        pendingActionsCount,
        setIsPendingActionsModalOpen,
    }: {
        collapsed: boolean, 
        sections: IPendingCardSection[],
        isLoading: boolean;
        pendingActionsCount: number;
        setIsPendingActionsModalOpen: (value: boolean | null) => void;
    }
) { 
    const navigate = useNavigate();
    const location = useLocation();
    if(sections.length !== 0 && !isLoading) {
        return (
            <div className="relative rounded-lg shadow-lg">
                <img 
                    src={PendingActionsCardTriangle} 
                    alt="Triangle"
                    className={` drop-shadow-xl absolute bottom-12 w-[27px] h-[22px] ${collapsed ? "left-[60px]" : "left-[280px]"} z-[250] mb-8 shadow-2xl`}
                />
                <div className={`fixed shadow-xl bottom-6 w-[380px] h-auto rounded-lg bg-white overflow-hidden z-[250] ${collapsed ? "left-[84px]" : "left-[300px]"}`}>
                    {sections.length !== 0 && !isLoading &&
                        <>
                        {
                            <>
                                <div>
                                    <div className="flex items-center justify-between pt-2 pb-2">
                                        <div className="w-[28px] h-[28px]" />
                                        <div className="flex justify-center items-center gap-2">
                                            <img
                                            src={WidgetLogoTransparent}
                                            alt="Widget Icon"
                                            className="w-[18px] h-[18px]"
                                            />
                                            <h2 className="text-[16px] leading-[150%] font-[600] text-[#D23636]">
                                                Pending Actions to get started
                                            </h2>
                                            <div className="flex h-[16px] w-[27px] items-center justify-center bg-[#D23636] text-white text-sm rounded-[5px]">
                                                {pendingActionsCount}
                                            </div>
                                        </div>
                                        <div className="flex justify-end items-center pr-2">
                                            <Tooltip title={'Close'} placement="top">
                                                <img
                                                    src={CloseIcon}
                                                    alt="close Icon"
                                                    className="w-[28px] h-[28px] hover:cursor-pointer"
                                                    onClick={() => {
                                                    setIsPendingActionsModalOpen(false);
                                                    }}
                                                />
                                            </Tooltip>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                            </>
                        }
                            <div className="pt-2 space-y-3 pb-4">
                                {sections.map((sc, i) => (
                                    <>
                                        <div className="flex gap-4 mx-6 my-2"> 
                                            <div className="w-[45px] h-[45px] rounded-[12px] border-[1px] bg-[#F5F7FA] border-[#9BB5EF] flex justify-center items-center">
                                            {sc.iconType === "error" && (sc.section_name === "knowHowToUseBuildr" ? 
                                                <img src={KnowHowToUseBuildrActionIcon} alt="Pending action" className="w-[24px] h-[24px]" /> : <img src={PendingActionsIcon} alt="Pending action" className="w-[24px] h-[24px]" />
                                            )
                                            }
                                            {sc.iconType === "success" &&
                                                <img src={CompletedActionsIcon} alt="Completed action" className="w-[24px] h-[24px]" />
                                            }
                                            </div>
                                            <div className="flex-1">
                                                <h3 className="font-[700] text-[15px] leading-[22.5px] text-[#222]">{sc.title}</h3>
                                                <p className="text-[#666666] font-[400] text-[13px] leading-[18px]">
                                                    {sc.shortDesc}
                                                </p>
                                                {sc.section_name === "addStudentDetails" && typeof sc.studentsAdded === "number" && 
                                                    <p className="text-[#666666] font-[600] text-[13px] leading-[18px]">
                                                {sc.studentsAdded === 0 
                                                        ? "0 students added." 
                                                        : `${sc.studentsAdded} ${sc.studentsAdded === 1 ? "student" : "students"} added successfully.`}
                                                </p> 
                                                }
                                                {sc.CTAText && 
                                                    <button 
                                                        onClick={() => {
                                                            setIsPendingActionsModalOpen(false);
                                                            if(sc.section_name === "computerLabSetup") {
                                                                if(sc.iconType === "success") {
                                                                    window.open(COMPUTER_LAB_SETUP_FEEDACK_LINK, "_blank");
                                                                }
                                                            }
                                                            if(sc.section_name === "addStudentDetails") {
                                                                if(sc.iconType === "success") {
                                                                    navigate("/student-list");
                                                                }
                                                                if(sc.iconType === "error") {
                                                                    navigate("/student-list?showMark=true");
                                                                }
                                                            }
                                                            if(sc.section_name === "knowHowToUseBuildr") {
                                                                if (location.pathname === '/lead-group-academy') {
                                                                    window.location.href = `/lead-group-academy?fromPendingActions=true&catId=${sections[0].lgaCatID}&tagNid=${sections[0].lgaTagNID}`;
                                                                } else {
                                                                    navigate(`/lead-group-academy?fromPendingActions=true&catId=${sections[0].lgaCatID}&tagNid=${sections[0].lgaTagNID}`);
                                                                }
                                                            }
                                                        }}
                                                        className="mt-2 flex items-center justify-center bg-[#527FED] px-4 py-2 text-sm font-medium text-white   w-[220px] rounded-[11.7px] text-[12.6px]">
                                                        {sc.CTAText} <BsChevronRight className="ml-1 h-4 w-2" />
                                                    </button>
                                                }
                                            </div>
                                        </div>
                                        {i !== sections.length - 1 && <hr />}
                                    </>
                                ))}
                            </div>
                        </>
                    } 
                </div>
            </div>
        );
    } else return <></>
}